/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { API } from "../backend";
import Swal from "sweetalert2";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  Container,
  Card,
  MenuItem,
  TextField,
} from "@mui/material";
import { useFlutterwave } from "flutterwave-react-v3";
// import Footer from '../../Component/Footer';
import axios from "axios";
import { Link } from "react-router-dom";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import Logo from "../../images/logo.png";
// import ProceedModal from "../../Component/ProceedModal"; // Ensure this is a default export
import { styled } from "@mui/system";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { MdDone, MdErrorOutline } from "react-icons/md";
import InputField from "../../Component/forms/input/TextInput/InputField";
import { closeModal } from "../../store/reducers/modal";
import InvoiceButtonWithConfirmation from "../../Component/InvoiceButtonWithConfirmation";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input.Mui-disabled": {
    color: "rgba(0,0,0,0.6) !important",
    "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
    borderColor: "rgba(0,0,0,0.6) !important",
  },
});

const ApplySchoolCode = () => {
  const navigate = useNavigate();
  const [school, setSchool] = useState("");
  const [examNameId, setexamNameId] = useState("");
  const [examName, setexamName] = useState("");
  const [localGovt, setLocalGovt] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [address, setAddress] = useState("");
  const [genInfo, setGenInfo] = useState([]);
  const [localGovtid, setLocalGovtId] = useState();
  const [formValues, setFormValues] = useState({
    examName: "",
    description: "",
    lga: "",
    payerId: "",
    schoolName: "",
    schoolAddress: "",
    categoryId: "",
    schoolType: "",
  });
  const [payerId, setPayerId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const [billablesPrice, setBillablesPrice] = useState([]);
  const [modelPrice, setModelPrice] = useState(
    formValues.examName === "BECE" ? "60000" : "50000",
  );
  const priceInt = modelPrice.replace(/\D/g, "");
  const totalFee = priceInt;
  const totalAmount = parseInt(totalFee);
  console.log(totalFee, "totalfeeeeeeeeeeeeee");

  const [schoolData, setSchoolData] = useState([]);
  console.log("schol data", schoolData);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [payerIdData, setPayerIdData] = useState(null);
  const [payerIdError, setPayerIdError] = useState();
  const [isReadOnly, setIsReadOnly] = useState(false); // State to track if the input should be read-only

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  // Set `payerId` and read-only status based on `schoolDetails.payerId`
  useEffect(() => {
    if (formValues?.payerId) {
      setPayerId(formValues.payerId);
      setIsReadOnly(true); // Make input read-only if `schoolDetails.payerId` is available
    } else {
      setIsReadOnly(false); // Allow input to be editable if no `schoolDetails.payerId`
    }
  }, [formValues]);
  const [open, setOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null); // Track which submenu is open

  const handleSubmenuClick = (menuName) => {
    setOpenSubmenu((prev) => (prev === menuName ? null : menuName));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const data = {
    Lga: [
      { ledId: "0001", name: "Agege" },
      { ledId: "0002", name: "Ajeriomi-Ifelodun" },
      { ledId: "0003", name: "Alimosho" },
      { ledId: "0004", name: "Amuwo-Odofin" },
      { ledId: "0005", name: "Apapa" },
      { ledId: "0006", name: "Badagry" },
      { ledId: "0007", name: "Epe" },
      { ledId: "0008", name: "Eti-Osa" },
      { ledId: "0009", name: "Ibeju-Lekki" },
      { ledId: "0010", name: "Ifako-Ijaye" },
      { ledId: "0011", name: "Ikeja" },
      { ledId: "0012", name: "Ikorodu" },
      { ledId: "0013", name: "Kosofe" },
      { ledId: "0014", name: "Lagos Island" },
      { ledId: "0015", name: "Lagos Mainland" },
      { ledId: "0016", name: "Mushin" },
      { ledId: "0017", name: "Ojo" },
      { ledId: "0018", name: "Oshodi-Isolo" },
      { ledId: "0019", name: "Somolu" },
      { ledId: "0020", name: "Surulere" },
      // { ledId: "0021", name: "Others" },
    ],
  };
  const Lga = data.Lga;

  const config = {
    public_key: process.env.REACT_APP_PUBLIC_KEY,
    tx_ref: Date.now(),
    amount: 5000,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email,
      phonenumber: phone,
    },
    customizations: {
      title: "Lagos Pay",
      description: "PAYMENT FOR EXAMINATION (CBS)",
      logo: "https://pbs.twimg.com/media/EtEwgbvXMAQfCXT.jpg",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const handlePayment = async () => {
    handleFlutterPayment({
      callback: (response) => {
        if (response.status === "successful") {
          paymentCode();
        }
      },
      onClose: () => {},
    });
  };

  const paymentCode = async () => {
    try {
      const body = {
        SchoolName: school,
        State: location,
        LgaName: localGovt,
        LgaId: localGovtid,
        PayerName: name,
        payeremail: email,
        Payerphone: phone,
        examName: examName,
      };
      console.log(body);

      const response = await axios.post(`${API}/beces/generateCode/`, body);
      console.log(response);

      if (response.status === 200) {
        Swal.fire({
          title: "Successful",
          text: `You have successfully apply for your school code , Your School Code is ${response.data[0].fields.SchoolId}`,
          icon: "success",
          confirmButtonText: "Ok",
        });

        setSchool("");
        setLocation("");
        setLocalGovt("");
        setLocalGovtId("");
        setexamNameId("");
        setName("");
        setPhone("");
        setEmail("");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // get price from billables

  const getExamBillable = async () => {
    const examBillable_url =
      formValues.examName === "BECE"
        ? `${API}/cbs/bece_billables`
        : `${API}/cbs/cas_billables`;
    // const examBillable_url = `${API}/cbs/college_billables`;

    try {
      const res = await axios.get(examBillable_url);
      // console.log(res);
      setBillablesPrice(res?.data?.data);
      // console.log(modelCollegeData);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    getExamBillable();
  }, [formValues.examName]);

  const handleClick = () => {
    handlePayment();
  };
  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/newApplication`, body);
      // console.log(res);
    } catch (error) {}
  };
  // apply

  const selectedLga = Lga.find((item) => item.name === formValues.lga);
  const applyCode = async () => {
    // Validate necessary data is present
    if (
      !payerIdData?.CUSTOMER_NAME ||
      !formValues.lga ||
      !formValues.examName
    ) {
      toast.error("Please fill out all required fields.");
      return;
    }

    // Dynamically construct the body object
    const body = {
      schoolName: payerIdData.CUSTOMER_NAME, // Dynamically set customer name
      lgaId: selectedLga.ledId || "", // Match LGA to ID
      lga: formValues.lga, // LGA name
      categoryId: formValues.categoryId,
      description: formValues.description, // Customize description dynamically if necessary
      assessmentCode: formValues.examName === "BECE" ? "04" : "03",
      payerId: formValues.payerId,
      schoolType: formValues.schoolType,
    };

    // Check if any required field in the body is missing
    if (!body?.lgaId || !body?.payerId) {
      toast.error("Missing required data to apply. Please check your inputs.");
      return;
    }
    try {
      const res = await axios.post(`${API}/newApplication/apply`, body);
      // console.log(res);
    } catch (error) {}
  };

  const generateBillNo = async () => {
    const fullDesc =
      formValues.examName === "BECE"
        ? "Basic Education Certification[NGN]"
        : "CAS examination";

    const body = {
      payer_id: formValues.payerId,
      customer_name: payerIdData?.CUSTOMER_NAME,
      selected_quantities: [1],
      assessmentCode: formValues.examName === "BECE" ? "04" : "03",
      selected_items: [
        formValues.examName === "BECE"
          ? parseInt(billablesPrice?.[6]?.PRODUCTS_ID) //retake billable while original is [1]
          : parseInt(billablesPrice?.[3]?.PRODUCTS_ID),
      ],
      selected_tariffs: [
        formValues.examName === "BECE" ? parseInt(60000) : parseInt(50000),
      ], ///retake bece
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice_newSchool`, body);
      if (res?.status === 200) {
        // console.log(res?.data)

        const billdata = {
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          customerName: payerIdData.CUSTOMER_NAME,
          assessmentCode: formValues.examName === "BECE" ? "04" : "03",
          item:
            formValues.examName === "BECE"
              ? parseInt(billablesPrice?.[6]?.PRODUCTS_ID) //retake billable while original is [1]
              : parseInt(billablesPrice?.[3]?.PRODUCTS_ID),
          amountGenerated:
            formValues.examName === "BECE" ? parseInt(60000) : parseInt(50000),
        };
        const bill = saveGeneratedBill(billdata);
        // console.log(bill)

        const userTransactionDetails = {
          fullDesc,
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          payerName: payerIdData?.CUSTOMER_NAME,
          productQuantity: 1,
          // price: amount,
          price:
            formValues.examName === "BECE" ? parseInt(60000) : parseInt(50000),
          // schoolName: "",
          examName,
          paymentExamType: examName,
          address: payerIdData?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        dispatch(setTransactionDetails(userTransactionDetails));
        dispatch(closeModal({ content: <></> }));
        navigate("/invoice");
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const backendMessage =
          error.response?.data?.message || "Something went wrong";
        toast.error(backendMessage);
      } else {
        toast.error("Unable to generate invoice, please try again later.");
      }
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true); // Show loading indicator

    try {
      // Ensure applyCode completes successfully
      const applyCodeSuccess = await applyCode();

      // // If applyCode didn't succeed or returned false, stop execution
      // if (!applyCodeSuccess) {
      //   return; // Exit early
      // }

      if (payerId) {
        await generateBillNo(); // Generate the bill number
        handleClose(); // Close the modal or dialog
      } else {
        toast.error("Number of candidates is required.");
      }
    } catch (error) {
      if (error.message === "Server Error: Something went wrong") {
        toast.error("Unable to generate invoice. Please try again later.");
      } else {
        toast.error(error.message);
      }
    } finally {
      setInvoiceLoading(false); // Hide loading indicator
    }
  };

  const payerIdVerification = async () => {
    try {
      const res = await axios.get(
        `${API}/cbs/customer_details?payerId=${formValues?.payerId}`,
      );
      // console.log(res);
      if (
        res.status === 200 &&
        payerId === res?.data?.data?.customer?.[0]?.PAYER_ID
      ) {
        setPayerIdError(null);
        // console.log(res?.data?.data?.customer?.[0]?.CUSTOMER_NAME);
        setPayerIdData(res?.data?.data?.customer?.[0]);
        toast.success(
          `Payer ID verified successfully, Customer Name: ${res?.data?.data?.customer?.[0]?.CUSTOMER_NAME}`,
          {
            autoClose: 10000,
          },
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.status === 404) {
        setPayerIdData(null);
        setPayerIdError(error?.response?.data?.message);
        toast.error(error?.response?.data?.message);
      }
      // console.log(error);
    }
  };

  const types = [
    {
      name: "",
      label: "",
    },
    {
      name: "BECE",
      label: "BECE",
    },
    {
      name: "CAS",
      label: "CAS",
    },
  ];
  const transaction = [
    { name: "schoolCode", label: "School Code" },
    { name: "changeOfStatus", label: "Change Of Status" },
    { name: "fullApproval", label: "Full Approval", indent: true },
    { name: "cecPublic", label: "CEC Public", indent: true },
    { name: "cecPrivate", label: "CEC Private", indent: true },
    { name: "changeOfName", label: "Change Of Name" },
  ];
  const description = [
    { name: "02", label: "Full Private School", indent: true },
    { name: "03", label: "Continuing Education Centre(Public)", indent: true },
    { name: "04", label: "Continuing Education Centre(Private)", indent: true },
  ];
  const schoolCas = [
    { name: "Public School", label: "Public School", indent: true },
    { name: "Full Private School", label: "Full Private School", indent: true },
  ];
  const schoolBece = [
    { name: "Public School", label: "Public School", indent: true },
    { name: "Full Private School", label: "Full Private School", indent: true },
    { name: "CEC (Public)", label: "CEC (Public)", indent: true },
    { name: "CEC (Private)", label: "CEC (Private)", indent: true },
  ];

  return (
    <div className="main-dues-container">
      <Box component="div" className="dues">
        <Container>
          <Card className="dues-card" elevation={5}>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              className="dues-form-left"
            >
              <Typography
                variant="h5"
                align="center"
                sx={{ paddingTop: "3rem", fontWeight: "bold" }}
              >
                Apply for School Code
              </Typography>

              <Container sx={{ mt: 5 }}>
                <div>
                  <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    <CustomTextField
                      id="demo-simple-select-standard"
                      label="Exam Type"
                      onChange={handleChange}
                      value={formValues.examName}
                      required
                      fullWidth
                      select
                      variant={"filled"}
                      name="examName"
                    >
                      {types.map((type, i) => (
                        <MenuItem key={i} value={type.name}>
                          {type.label}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </div>
                  <div className="mt-6">
                    {formValues?.examName === "BECE" ? (
                      <CustomTextField
                        id="demo-simple-select-standard"
                        label="School Type"
                        fullWidth
                        value={formValues.schoolType}
                        onChange={handleChange}
                        select
                        name="schoolType"
                        variant="filled"
                      >
                        {schoolBece?.map((type) => (
                          <MenuItem
                            key={type.name}
                            value={type.name}
                            disabled={type.isHeader}
                            style={type.indent ? { paddingLeft: "2rem" } : {}}
                          >
                            {type?.label}
                          </MenuItem>
                        ))}
                      </CustomTextField>
                    ) : (
                      <CustomTextField
                        id="demo-simple-select-standard"
                        label="School Type"
                        fullWidth
                        value={formValues.schoolType}
                        onChange={handleChange}
                        select
                        name="schoolType"
                        variant="filled"
                      >
                        {schoolCas?.map((type) => (
                          <MenuItem
                            key={type.name}
                            value={type.name}
                            disabled={type.isHeader}
                            style={type.indent ? { paddingLeft: "2rem" } : {}}
                          >
                            {type?.label}
                          </MenuItem>
                        ))}
                      </CustomTextField>
                    )}
                  </div>
                  <div className="mt-6">
                    <CustomTextField
                      id="demo-simple-select-standard"
                      label="Transaction Type"
                      fullWidth
                      value={formValues.description}
                      onChange={handleChange}
                      select
                      name="description"
                      variant="filled"
                    >
                      {transaction.map((type) => (
                        <MenuItem
                          key={type.name}
                          value={type.name}
                          disabled={type.isHeader}
                          style={type.indent ? { paddingLeft: "2rem" } : {}}
                        >
                          {type.label}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </div>
                  <div className="mt-6">
                    <CustomTextField
                      id="demo-simple-select-standard"
                      label="School Category"
                      fullWidth
                      required
                      value={formValues.categoryId}
                      onChange={handleChange}
                      select
                      name="categoryId"
                      variant="filled"
                    >
                      {description.map((type) => (
                        <MenuItem
                          key={type.name}
                          value={type.name}
                          disabled={type.isHeader}
                          style={type.indent ? { paddingLeft: "2rem" } : {}}
                        >
                          {type.label}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </div>

                  <div style={{ marginTop: "1rem" }}>
                    <CustomTextField
                      id="standard-basic"
                      label="Select Local Government Area"
                      select
                      required
                      value={formValues.lga}
                      onChange={handleChange}
                      variant="standard"
                      fullWidth
                      className="dues-form-field"
                      name={"lga"}
                    >
                      {Lga.map((lgaItem) => (
                        <MenuItem key={lgaItem.ledId} value={lgaItem.name}>
                          {lgaItem.name}
                        </MenuItem>
                      ))}
                    </CustomTextField>
                  </div>

                  <div>
                    <CustomTextField
                      id="standard-basic"
                      label="PayerId(Coperate)"
                      variant="standard"
                      fullWidth
                      className="dues-form-field"
                      onChange={handleChange}
                      value={formValues.payerId}
                      onBlur={() => payerIdVerification()}
                      name="payerId"
                    />
                    {payerIdError ? (
                      <span
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "5px",
                          color: "red",
                        }}
                      >
                        Payer ID unverified <MdErrorOutline />
                      </span>
                    ) : payerIdData ? (
                      <span
                        style={{
                          fontSize: "14px",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "5px",
                          color: "green",
                        }}
                      >
                        Payer ID verified <MdDone />
                      </span>
                    ) : null}
                  </div>

                  <div style={{ flexDirection: "column", gap: "1rem" }}>
                    <InputField
                      name="schoolName"
                      label="Schhol Name"
                      required
                      readOnly
                      type="text"
                      placeholder="School Name"
                      value={payerIdData?.CUSTOMER_NAME}
                      style={{ height: "100%" }}
                    />
                    <InputField
                      name="schoolAddress"
                      label="Schhol Address"
                      required
                      readOnly
                      type="text"
                      placeholder="School Address"
                      value={payerIdData?.ADDRESS}
                      style={{ height: "100%" }}
                    />
                  </div>

                  <div style={{ marginTop: "3rem" }}>
                    <Button
                      color="success"
                      variant="contained"
                      sx={{
                        textTransform: "inherit",
                        fontWeight: "bold",
                        mr: "5px",
                      }}
                      onClick={handleOpen}
                      // disabled={schoolId === '' ? true : false}
                    >
                      Preview
                    </Button>

                    <Link
                      component="button"
                      to="/"
                      sx={{ textDecoration: "none" }}
                    >
                      <Button
                        variant="text"
                        sx={{
                          textTransform: "inherit",
                          fontWeight: "bold",
                          ml: "5px",
                          color: "black",
                        }}
                      >
                        Go back
                      </Button>
                    </Link>
                  </div>
                </div>
              </Container>
            </Box>
            <Box compnent="div" className="dues-form-right">
              <Typography
                variant="h4"
                align="center"
                sx={{
                  color: "#ffffff",
                  paddingTop: "3rem",
                  fontWeight: "bold",
                }}
              >
                Lagos State Exam Board
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5rem",
                }}
              >
                <img src={Logo} alt="logo" />
              </div>
              <Typography
                variant="h4"
                align="center"
                sx={{ color: "white", paddingTop: "2rem", fontWeight: "bold" }}
              >
                Apply For School Code
              </Typography>
              <Typography
                variant="body2"
                align="center"
                sx={{ color: "white", padding: ".3rem 1rem" }}
              >
                Fill the form to request for the Official Central Billing System
                Invoice ID
              </Typography>
            </Box>
          </Card>
        </Container>
        {/* <ProceedModal piepie={pinNum} open={open} handleClose={handleClose} /> */}
      </Box>
      {/* <Footer /> */}
      {/* Modal for Preview */}
      <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>Form Preview</DialogTitle>
        <DialogContent dividers>
          <Typography variant="h6" gutterBottom>
            School Type: {formValues.examName}
          </Typography>
          <Typography variant="h6" gutterBottom>
            Transaction Type: {formValues.description}
          </Typography>
          <Typography variant="h6" gutterBottom>
            Local Government Area Code:{" "}
            {selectedLga ? selectedLga.ledId : "N/A"}
          </Typography>
          <Typography variant="h6" gutterBottom>
            Local Government Area Name: {formValues.lga}
          </Typography>
          <Typography variant="h6" gutterBottom>
            Payer ID: {formValues.payerId}
          </Typography>
          <Typography variant="h6" gutterBottom>
            School Name: {payerIdData?.CUSTOMER_NAME}
          </Typography>
          <Typography variant="h6" gutterBottom>
            School Address: {payerIdData?.ADDRESS}
          </Typography>
          <Typography variant="h6" gutterBottom>
            Price: ₦
            {formValues.examName === "BECE"
              ? billablesPrice?.[6]?.SALE_PRICE
              : billablesPrice?.[3]?.SALE_PRICE}
          </Typography>
        </DialogContent>
        <DialogActions>
          <InvoiceButtonWithConfirmation
            invoiceLoading={invoiceLoading}
            handleInvoiceClick={handleInvoiceClick}
          />

          <Button onClick={handleClose} variant="text">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ApplySchoolCode;
